export default "__VITE_ASSET__4244a117__"